exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._10SfQ1NO1Na4o48OLx_f_E{padding:0}html[dir=ltr] ._1-gunxX2rNsokXRa-fRmf9{padding-left:20px}html[dir=rtl] ._1-gunxX2rNsokXRa-fRmf9{padding-right:20px}html[dir=ltr] ._31DpYcGoDCnF9KPfXcmzgh{margin-left:20px}html[dir=rtl] ._31DpYcGoDCnF9KPfXcmzgh{margin-right:20px}", ""]);
// Exports
exports.locals = {
	"insightsContainer": "_10SfQ1NO1Na4o48OLx_f_E",
	"insightsContent": "_1-gunxX2rNsokXRa-fRmf9",
	"relatedContentHeaderSubText": "_31DpYcGoDCnF9KPfXcmzgh"
};